import React from 'react';

const FaceIcon = (props) => {
  if(props.user.shock) {
    return (<i className="fas fa-surprise fa-lg"></i>);
  } else {
    return (<i className="fal fa-surprise fa-lg"></i>);
  }
}
export default FaceIcon;